import { getVersions, getLocation } from '@fabric-app/compat';

const getDefaultTrackedProperties = async () => {
  const versions = await getVersions();
  return {
    location: getLocation(),
    webVersion: versions.webVersion ?? null,
    appVersion: versions.appVersion ?? null,
    desktopVersion: versions.desktopVersion ?? null,
    ...window.fabricMobile ? {
      inShareSheet: true
    } : void 0
  };
};

export { getDefaultTrackedProperties };
//# sourceMappingURL=getDefaultTrackedProperties.js.map
